// NOTE: key 'DEPOT_LIST' is used by many useSelector hooks throughout the app

import registerDepotRedux from 'app/resources/depot';
import { useSelector } from 'react-redux';

const key = 'DEPOT_LIST';

export const depotListRedux = registerDepotRedux(key, ['GET', 'LIST']);

export const useDepotList = () => useSelector((state) => state[key]);
